import { makeStyles } from '@mui/styles';
import { lighten, Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {},
    meta: {
      columnGap: theme.spacing(1),
      '& strong': {
        marginLeft: theme.spacing(1),
        color: theme.palette.grey[700],
      },
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    leftColumn: {
      flex: '0 1 auto',
      [theme.breakpoints.down('md')]: {
        flex: '0 1 100%',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
      },
    },
    rightColumn: {
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-end',
      flexDirection: 'row',
      columnGap: '10px',
      [theme.breakpoints.down('sm')]: {
        flex: 'unset',
        flexDirection: 'column',
        rowGap: theme.spacing(1),
      },
    },
    content: {
      width: '550px',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        width: '100%',
      },
    },
    searchBox: {
      padding: theme.spacing(2),
      borderRadius: '8px',
      backgroundColor: theme.palette.grey[200],
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(1),
      },
    },
    listItemView: {
      marginRight: '65px',
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      },
    },
    listView: {
      overflowY: 'auto',
      marginTop: '8px',
      maxHeight: '500px',
      width: '100%',
      borderRadius: '5px',
      backgroundColor: theme.palette.background.paper,
    },
    listItem: {
      cursor: 'pointer',
      padding: '8px 16px',
      borderBottom: `solid 1px ${theme.palette.grey[200]}`,
      [theme.breakpoints.down('md')]: {
        padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
      },
    },
    greyText: {
      color: theme.palette.grey[900],
    },
    iconCheckout: {
      marginTop: theme.spacing(0.2),
      fontSize: '16px',
      color: theme.palette.grey[800],
    },
    iconButton: {
      borderRadius: '5px',
      backgroundColor: theme.palette.grey[50],
      color: theme.palette.grey[800],
    },
    menuItemPlaceholder: {
      display: 'flex',
      alignItems: 'center',
    },
    pagination: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(2),
    },
    selectMenu: {
      '& .MuiSelect-select': {
        display: 'flex',
        alignItems: 'center',
      },
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(2),
      columnGap: '10px',
      '& button': {
        maxWidth: '30%',
      },
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-start',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        '& button': {
          maxWidth: 'unset',
        },
      },
    },
    incidentsBadge: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '32px',
      height: '32px',
      borderRadius: '5px',
      backgroundColor: theme.palette.grey[400],
      color: theme.palette.grey[50],
    },
    closeIconContainer: {
      position: 'absolute',
      right: 2,
      top: 0,
      cursor: 'pointer',
    },
    createButton: {
      backgroundColor: theme.palette.common.white,
      borderWidth: 1.5,
      borderColor: lighten(theme.palette.primary.dark, 0.3),
      '&:hover': {
        backgroundColor: lighten(theme.palette.primary.main, 0.7),
      },
    },
    titleBox: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      columnGap: '10px',
      height: '40px',
      '& hr': {
        flex: 1,
      },
    },
    titleBoxText: {
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('md')]: {
        maxWidth: '250px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
  };
});

export default useStyles;
